<template>
  <div>
    <v-scroll-x-transition :hide-on-leave="true">
      <v-card
        v-if="stepState.showTaskState"
        flat
      >
        <v-card-actions class="py-0 ps-4">
          <v-btn
            @click="toggleTaskState(false)"
            small
            text
            outlined
          >
            <v-icon small>mdi-arrow-left</v-icon>&nbsp;Вернуться к списку
          </v-btn>
        </v-card-actions>

        <v-card-title>{{ stepState.stepData.name }}</v-card-title>
        <v-card-subtitle>{{ stepState.stepData.description }}</v-card-subtitle>

        <v-card-text>
          <pre class="text-pre-wrap overflow-auto" style="max-height: 70vh;">{{ JSON.stringify(stepState.taskStateData, null, 2) }}</pre>
        </v-card-text>
      </v-card>
    </v-scroll-x-transition>

    <v-simple-table
      v-show="!stepState.showTaskState"
      class="log"
      style="width: 100%; table-layout: fixed;"
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th>Дата</th>
          <th style="width: 35%;">Название</th>
          <th>Описание</th>
          <th>Состояние</th>
        </tr>
        </thead>
        <tbody v-for="(item, i) in logList" :key="i">
          <tr>
            <td>
              <span>{{ new Date(item.dadd).toLocaleDateString() }}</span> &nbsp;
              <small class="text--secondary">{{
                  new Date(item.dadd).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
                }}</small>
            </td>
            <td style="overflow-wrap: anywhere;">{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>
              <StatusChip :value="item.status" />
              <v-btn
                v-if="item.taskid"
                color="secondary lighten-2"
                @click="toggleTaskState(true, item)"
                small
                icon
                plain
                :ripple="false"
              >
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatusChip from "@/components/common/StatusChip";
import {fetchTaskData} from "@/api/app";

export default {
  name: "AppTableLog",

  components: { StatusChip },

  data() {
    return {
      stepState: {
        showTaskState: false,
        stepData: null,
        taskStateData: null
      },
    }
  },

  computed: {
    ...mapGetters("app", ["logList", "model"]),
  },

  methods: {
    async toggleTaskState(show, item)
    {
      show = Boolean(show);

      if (show)
      {
        const response = await fetchTaskData({taskId: item.taskid});
        if (!response) {
          return;
        }

        this.stepState.taskStateData = response;
      }
      else {
        this.stepState.taskData = null;
      }

      this.stepState.stepData = item;
      this.$set(this.stepState, 'showTaskState', show);
    }
  },
};
</script>

<style lang="scss" scoped>
.log > .v-data-table__wrapper > table > tbody > tr > td {
  height: 30px !important;
}

th,
td {
  border: 1px solid #eaeaea;
}
.v-data-table > .v-data-table__wrapper > table {
  width: 100% !important;
}
</style>
